// Modal-variant TOC sheet. Thin wrapper around BottomSheet — backdrop,
// focus trap, Escape live in the primitive. We own the section list and
// the goToSection callback. Active section is highlighted in the accent
// color.

import type { Section } from "../data/types";
import { BottomSheet } from "./BottomSheet";

export interface SectionSheetProps {
  open: boolean;
  sections: Section[];
  activeSectionId: string | null;
  onSelect: (id: string) => void;
  onClose: () => void;
}

export function SectionSheet({
  open, sections, activeSectionId, onSelect, onClose,
}: SectionSheetProps) {
  return (
    <BottomSheet
      open={open}
      variant="modal"
      onClose={onClose}
      aria-label="Section navigator"
      className="maisight-toc-sheet"
    >
      <div className="maisight-toc-grabber" aria-hidden="true" />
      <div className="maisight-toc-head">Contents</div>
      <nav className="maisight-toc-list" aria-label="Sections">
        {sections.map((s) => {
          const isActive = s.id === activeSectionId;
          return (
            <button
              key={s.id}
              type="button"
              className={`maisight-toc-item${isActive ? " is-active" : ""}`}
              onClick={() => {
                onSelect(s.id);
                onClose();
              }}
            >
              {s.heading ?? s.id}
            </button>
          );
        })}
      </nav>
    </BottomSheet>
  );
}
